import { createSlice } from '@reduxjs/toolkit';

const initialState = {
   isLoading: false,
};

export const appUi = createSlice({
   name: 'superAdminAuth',
   initialState,

   reducers: {
      loading: (state, action) => {
         const { payload } = action;
        //  console.log('payload', payload);
         return {
            ...state,
            isLoading: payload,
         };
      },
   },
});

export const { loading } = appUi.actions;

export default appUi.reducer;
